import React, { useState } from "react";

//Components
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Modal from "../../../components/ModalActions";
import ModalSuccess from "../../../components/ModalSuccessMessage";
import Input from "../../../components/Input";
import Button from "../../../components/Button";

//Styles
import {
    Container,
    ContentContainer,
    FormContainer,
    FormTitle,
    TextArea,
    TextAreaLegend,
    BalanceContainer,
    BalanceSendContainer,
    BalanceSendDescriptionContainer,
    BalanceSendDescriptionTitle,
    BalanceSendDescriptionQuantity,
    ClientsContainer,
    ClientsNumber,
    ClientsTitle,
    ModalShareRow,
    ButtonShare,
    ButtonShareText,
    ButtonContainer
} from "./styles";

//Help Functions
import { openModal, closeModal } from "../../../helpers/modalFunctions";

//Data
import routes from "../../../routes/clientClientPortal.routes";

//Assets
import whatsappOrange from "../../../assets/icons/whatsappOrange.svg";
import emailOrange from "../../../assets/icons/mailOrange.svg";
import phoneOrange from "../../../assets/icons/phoneOrange.svg";
import team from "../../../assets/icons/team-big.svg";
import whatsappGreen from "../../../assets/icons/whatsapp.svg";
import mailRed from "../../../assets/icons/mailRed.svg";
import smsIcon from "../../../assets/icons/phone.svg";
import whatsappWhite from "../../../assets/icons/whatsappWhite.svg";
import mailWhite from "../../../assets/icons/mailWhite.svg";
import smsIconWhite from "../../../assets/icons/smsIconWhite.svg";

const MessageCampaign = () => {
    const [isWhatsappSelected, setIsWhatsappSelected] = useState(false);
    const [isEmailSelected, setIsEmailSelected] = useState(false);
    const [isSmsSelected, setIsSmsSelected] = useState(false);

    const handleSendClick = () => {
        closeModal("sendMessageCampaign");
        openModal("exampleModal");
    }
    
    return(
        <Container>
            <Header
                title="Clientes"
                subTitle="Visualize e gerencie toda a sua base de clientes em um só lugar"
                subTitleWidth={229}
            />
            <NavTabs tabs={routes}/>

            <Modal id="sendMessageCampaign" title="Selecione os tipos de envios" titleSize={28}>
                <div>
                    <ModalShareRow>
                        <ButtonContainer onClick={() => setIsWhatsappSelected(!isWhatsappSelected)}>
                            <ButtonShare color={isWhatsappSelected ? "#FFFFFF" : "#1EF591"} background={isWhatsappSelected ? "#1EF591" : "#FFFFFF"}>
                                <img src={isWhatsappSelected ? whatsappWhite : whatsappGreen}/>
                                <ButtonShareText>Enviar para whatsapp</ButtonShareText>
                            </ButtonShare>
                        </ButtonContainer>

                        <BalanceSendContainer style={{margin: 0}}>
                            <img src={whatsappOrange} alt="whats" />

                            <BalanceSendDescriptionContainer>
                                <BalanceSendDescriptionTitle>Whatsapp</BalanceSendDescriptionTitle>
                                <BalanceSendDescriptionQuantity>1.000</BalanceSendDescriptionQuantity>
                            </BalanceSendDescriptionContainer>
                        </BalanceSendContainer>
                    </ModalShareRow>

                    <ModalShareRow>
                        <ButtonContainer onClick={() => setIsEmailSelected(!isEmailSelected)}>
                            <ButtonShare color={isEmailSelected ? "#FFFFFF" : "#F46B45"} background={isEmailSelected ? "#F46B45" : "#FFFFFF"}>
                                <img src={isEmailSelected ? mailWhite : mailRed}/>
                                <ButtonShareText>Enviar por email</ButtonShareText>
                            </ButtonShare>
                        </ButtonContainer>

                        <BalanceSendContainer style={{margin: 0}}>
                            <img src={emailOrange} alt="email" />

                            <BalanceSendDescriptionContainer>
                                <BalanceSendDescriptionTitle>Email</BalanceSendDescriptionTitle>
                                <BalanceSendDescriptionQuantity>Ilimitado</BalanceSendDescriptionQuantity>
                            </BalanceSendDescriptionContainer>
                        </BalanceSendContainer>
                    </ModalShareRow>

                    <ModalShareRow style={{marginBottom: 28}}>
                        <ButtonContainer onClick={() => setIsSmsSelected(!isSmsSelected)}>
                            <ButtonShare color={isSmsSelected ? "#FFFFFF" : "#F58B1E"} background={isSmsSelected ? "#F58B1E" : "#FFFFFF"}>
                                <img src={isSmsSelected ? smsIconWhite : smsIcon}/>
                                <ButtonShareText>Enviar SMS</ButtonShareText>
                            </ButtonShare>
                        </ButtonContainer>

                        <BalanceSendContainer style={{margin: 0}}>
                            <img src={phoneOrange} alt="phone" />

                            <BalanceSendDescriptionContainer>
                                <BalanceSendDescriptionTitle>SMS</BalanceSendDescriptionTitle>
                                <BalanceSendDescriptionQuantity>1.000</BalanceSendDescriptionQuantity>
                            </BalanceSendDescriptionContainer>
                        </BalanceSendContainer>                        
                    </ModalShareRow>

                    <ModalShareRow>
                        <ButtonContainer>
                            <Button onClick={handleSendClick}>Enviar Mensagens</Button>    
                        </ButtonContainer>

                        <ClientsContainer style={{margin: 0}}>
                            <div>
                                <ClientsNumber>350</ClientsNumber>
                                <ClientsTitle>Nº DE CLIENTES</ClientsTitle>
                            </div>

                            <img src={team} alt="clients" style={{width: 28, marginLeft: 1}}/>
                        </ClientsContainer>
                    </ModalShareRow>
                </div>
            </Modal>

            <ModalSuccess text="Enviado com Sucesso"/>
            <ContentContainer>
                <div>
                    <FormTitle>Saldo de envio</FormTitle>
                    <BalanceContainer>
                        <ClientsContainer>
                            <div>
                                <ClientsNumber>350</ClientsNumber>
                                <ClientsTitle>Nº DE CLIENTES</ClientsTitle>
                            </div>

                            <img src={team} alt="clients" style={{width: 28, marginLeft: 1}}/>
                        </ClientsContainer>

                        <BalanceSendContainer>
                            <img src={whatsappOrange} alt="whats" />

                            <BalanceSendDescriptionContainer>
                                <BalanceSendDescriptionTitle>Whatsapp</BalanceSendDescriptionTitle>
                                <BalanceSendDescriptionQuantity>1.000</BalanceSendDescriptionQuantity>
                            </BalanceSendDescriptionContainer>
                        </BalanceSendContainer>
                        <BalanceSendContainer>
                            <img src={emailOrange} alt="email" />

                            <BalanceSendDescriptionContainer>
                                <BalanceSendDescriptionTitle>Email</BalanceSendDescriptionTitle>
                                <BalanceSendDescriptionQuantity>Ilimitado</BalanceSendDescriptionQuantity>
                            </BalanceSendDescriptionContainer>
                        </BalanceSendContainer>
                        <BalanceSendContainer>
                            <img src={phoneOrange} alt="phone" />

                            <BalanceSendDescriptionContainer>
                                <BalanceSendDescriptionTitle>SMS</BalanceSendDescriptionTitle>
                                <BalanceSendDescriptionQuantity>1.000</BalanceSendDescriptionQuantity>
                            </BalanceSendDescriptionContainer>
                        </BalanceSendContainer>
                    </BalanceContainer>
                </div>
                
                <FormContainer>
                    <FormTitle>Enviar mensagem para clientes</FormTitle>
                    <Input placeholder="Titulo" className="inputCustom"/>

                    <TextArea placeholder="Mensagem"/>
                    <TextAreaLegend>Máximo de Caracteres: 100</TextAreaLegend>

                    <Button style={{marginBottom: 32}} onClick={() => openModal("sendMessageCampaign")}>
                        Definir envios
                    </Button>
                </FormContainer>

            </ContentContainer>
        </Container>
    )
}

export default MessageCampaign;